import { useIntl } from 'react-intl';

import { mapApiErrorCode } from '@/errorCodes/helpers';

import { isErrorNotification } from '@/components/Header/components';
import { getFormattedMessage } from '@/components/ServerErrors';
import { Typography } from '@/components/Typography';
import { useCheckout } from '@/hooks/useCheckout';

import { ReactComponent as InfoBadge } from '@/assets/icons/info-badge-grey.svg';

import * as S from './ErrorShoppingBag.styles';

export const ErrorShoppingBag = () => {
  const { formatMessage } = useIntl();
  const {
    snapshot: { notification },
  } = useCheckout();

  return (
    <>
      {isErrorNotification(notification) &&
        notification.map((error, i) => {
          const message = getFormattedMessage(
            error,
            formatMessage,
            mapApiErrorCode,
          );
          if (!message) {
            return;
          }
          return (
            <S.AlertMessage
              key={i}
              alignItems='center'
              data-test-id={`ShoppingBagDrawerAlertMessage-${i}`}
              type='warning'
            >
              <InfoBadge width='20' />
              <Typography>{message}</Typography>
            </S.AlertMessage>
          );
        })}
    </>
  );
};

export default ErrorShoppingBag;
